// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"349":"c3a71a48","434":"7fe95281","902":"40bf7a82"}[chunkId] + ".chunk.css";
};